export class SkyLinkRecordsMatchesSetStatusAction {
  constructor(
    public key: string,
    public status: string
  ) {}
}
